import useInitiateAccountDataExport from '@/api/mutations/account/useInitiateAccountDataExport';
import { Alert, Button } from '@payaca/ambrosia';
import { FC, useState } from 'react';

const CompanySettingsDataExport: FC = () => {
  const [submitted, setSubmitted] = useState(false);
  const [errorMessage, setErrorMessage] = useState<string | null>(null);

  const { mutate, isPending } = useInitiateAccountDataExport({
    onSuccess: (data) => {
      if (
        data.initiateAccountDataExport.__typename ===
        'InitiateAccountDataExportSuccess'
      ) {
        setSubmitted(true);
      } else {
        setErrorMessage(data.initiateAccountDataExport.message);
      }
    },
  });

  return (
    <div className="flex w-full flex-col items-start gap-y-4">
      <div className="typography:prose">
        <h2>Export account data</h2>
        <p>
          Export your account data — customers, projects and their files — as a
          zip of CSV files. The project files CSV includes time-limited download
          links for each file. We&apos;ll email you a link to download the
          export when it is ready.
        </p>
      </div>

      {errorMessage && (
        <Alert colour="red" className="w-full">
          {errorMessage}
        </Alert>
      )}

      {submitted ? (
        <Alert colour="green" className="w-full">
          We&apos;re preparing your export. You&apos;ll receive an email with a
          download link when it is ready.
        </Alert>
      ) : (
        <Button isProcessing={isPending} onClick={() => mutate()}>
          Export account data
        </Button>
      )}
    </div>
  );
};

export default CompanySettingsDataExport;
